import { Alert, AlertTitle, Button, Stack, Box } from '@mui/material';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

export type GuestUserProfilePageContentProps = {
  /**
   * Callback function when the sign in button is clicked.
   */
  onSignIn: () => void;
};

/**
 * A profile page component that displays information for guest users.
 * Shows an info message encouraging login and a warning about potential data loss.
 */
export const GuestUserProfilePageRenderer = ({
  onSignIn,
}: GuestUserProfilePageContentProps) => (
  <CenteredLayout horizontal vertical>
    <Stack spacing={5}>
      <Stack spacing={1}>
        <Alert severity="info">
          <AlertTitle>Guest Mode</AlertTitle>
          Sign in to preserve your information and access additional features.
        </Alert>

        <Alert severity="warning">
          <AlertTitle>Data Loss Risk</AlertTitle>
          Your data may be lost if you don't sign in. Please log in to ensure
          your information is saved securely.
        </Alert>
      </Stack>

      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
        <Button variant="contained" size="large" onClick={onSignIn}>
          Sign In
        </Button>
      </Box>
    </Stack>
  </CenteredLayout>
);
